<template>
  <div class="new-from-brand" v-if="products && products.length">
    <div class="new-from-header flex align-center justify-between flex-wrap">
      <h2 class="section-title">More from {{ brandName }}</h2>
      <bulletin-button :to="`/brands/${brandVanityUrlName}?page=1&sortBy=created_at_asc`" class="see-all-button"
        >See All</bulletin-button
      >
    </div>

    <div class="products-grid" v-if="products && products.length">
      <product-tile
        v-for="(product, i) in products"
        :key="'product_' + product.id + '_' + i"
        :i="i"
        :data="product"
        :quick-shop="true"
        :fit-height="true"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_mixins.scss";

.new-from-brand {
  margin-bottom: 72px;
}

.new-from-header {
  margin-bottom: 24px;

  .section-title {
    font-size: 32px;
  }

  .see-all-button {
    @include respond-to("small") {
      margin-top: 8px;
    }
  }
}

.products-grid {
  display: grid;
  width: 100%;
  grid-row-gap: 40px;
  grid-column-gap: 24px !important;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 24px;

  @include respond-to("small") {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 24px;
  }
}
</style>

<script>
import { algoliaProductHelper } from "../../../components/mixin/search/algoliaProductHelper";
import { searchPageMobileStateHelper } from "../../../components/mixin/search/searchPageMobileStateHelper";
import { mapGetters } from "vuex";

export default {
  data: () => {
    return {
      products: [],
    };
  },
  mixins: [algoliaProductHelper, searchPageMobileStateHelper],
  props: {
    brandName: {
      type: String,
    },
    brandId: {
      type: String,
    },
    brandVanityUrlName: {
      type: String,
      default: "",
    },
  },
  async beforeMount() {
    this.getProductsOnSearch({ page: 1, sortBy: "created_at_asc" }, { brandId: this.brandId }, 4);
  },
  watch: {
    favoriteList() {
      this.products = this.applyFavorites(this.products);
    },
  },
  computed: {
    ...mapGetters({
      favoriteList: "favoriteProductsState",
    }),
  },
};
</script>
